<template>
  <div class="twitter-post-grid">
    <post-grid-item
      v-for="(post, index) in posts"
      :key="index"
      :post="post"
      snsType="twitter"
      :campaignType="campaignType"
      @change_is_widget="changeIsWidget"
      @change_is_candidate="changeIsCandidate"
      @change_is_winner="changeIsWinner"
      @change_ng="changeNg"
    ></post-grid-item>
    <div layout layout-align="space-between-center">
      <pagination
        flex="1"
        :total="options.total"
        :pagingNo="options.pagingNo"
        :limitCount="options.limitCount"
        @paging="onPaging"
      ></pagination>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import Pagination from '@/client/components/_atoms/pagination'
import PostGridItem from '@/client/components/_atoms/post_grid_item'

export default defineComponent({
  props: {
    posts: Array,
    options: Object,
    campaignType: String
  },
  components: {
    Pagination,
    PostGridItem
  },
  methods: {
    /**
     * ウィジェットフラグを変更
     */
    changeIsWidget(payload: { postId: string; isWidget: number }) {
      this.$emit('change_is_widget', payload)
    },

    /**
     * 候補者フラグを変更
     */
    changeIsCandidate(payload: { applicantId: number; isCandidate: number }) {
      this.$emit('change_is_candidate', payload)
    },

    /**
     * 当選者フラグを変更
     */
    changeIsWinner(payload: { prizeId: number; applicantId: number; isWinner: number }) {
      this.$emit('change_is_winner', payload)
    },

    /**
     * ページング変更イベント
     */
    onPaging(payload: { pagingNo: number; limitCount?: number }) {
      this.$emit('paging', payload)
    },

    /**
     * NGアカウントフラグを変更（伝播）
     */
    changeNg(payload: { screenName: string; isNg: boolean; ngApplicantId: number | null }) {
      this.$emit('change_ng', payload)
    }
  }
})
</script>
